// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"160a3157","373":"2bb2f525","787":"6de9dcf1","789":"c926881a","984":"d8d8a5a2"}[chunkId] + ".chunk.js";
};